import { Pipe, PipeTransform } from '@angular/core';

/** Renders Infinity / non-finite credit balances as "infinite". */
@Pipe({
  name: 'creditsLabel',
  standalone: true,
})
export class CreditsLabelPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (
      value === 'Unlimited' ||
      value === '∞' ||
      value === 'infinite' ||
      value === 'Infinite'
    ) {
      return 'infinite';
    }
    if (value != null && value !== '' && !Number.isFinite(Number(value))) {
      return 'infinite';
    }
    if (value == null || value === '') {
      return '—';
    }
    return String(value);
  }
}
